import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';

@Component({
    selector: 'bm-bank-transaction-domain-details',
    templateUrl: 'bm-bank-transaction-domain-details.component.html',
    standalone: false
})
export class BmBankTransactionDomainDetailsComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() bankTransactionDomainId: number;

    bankTransactionDomainWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        this.bankTransactionDomainWidgetData = WidgetFactory.createWidgetEntityData(
            'bm.bank.transaction.domain.details.widget.data',
            'Banktransaktionsdomaene',
            'bm.BankTransactionDomain',
            this.bankTransactionDomainId
        );
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['bankTransactionDomainId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
